import React, { Component } from 'react';
import { _Alert, variable, _post, _getToken } from './Function';
import InputMask from 'react-input-mask';
import Modal from 'react-responsive-modal';
import '../css/Dashboard.css';

class ModalGenaral extends Component {
    constructor(props) {
        super(props);
        this.state={
            is_show: this.props.onShowGenaralModal,
            component: this.props.onComponent,
            tel: this.props.onInfo.tel,
            mobile: this.props.onInfo.mobile,
            email: this.props.onInfo.email,
        }
    }

    update = (t, e) => { this.setState({ [t]: e.target.value }) }

    EditDataGenaral = (t) => {
        if ( t === 'email' ) {
            if ( this.state.email.length ) {
                let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/ ;
                if(reg.test(this.state.email) === false){
                    _Alert('modify', 'error', 'แจ้งเตือน', 'กรุณากรอก e-mail ให้ถูกต้อง');
                    return;
                }
            }
            this.props.closeGenaralModal();
            this.setState({ is_show: false }); 
            let param = { token: _getToken(), platform: variable().platform, data_type: t, data_edit: this.state.email };
            _post('web.edit.dashboard.php', param)
            .then(res => {
                if ( res.data.status ) { 
                    this.props.onFallback(true);
                    _Alert('modify', 'success', 'แก้ไขข้อมูลสำเร็จแล้ว', 'แก้ไขข้อมูลสำเร็จแล้ว');
                } else {
                    this.setState({ loadingShow: false });
                    if ( res.data.responseText === 101 ) {
                        localStorage.clear();
                        _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
                    } else {
                        _Alert('modify', 'error', 'แจ้งเตือน', res.data.responseText);
                    }
                }
            }).catch(err => { 
                this.setState({ loadingShow: false }); 
                _Alert('error'); 
            });
        } else if ( t === 'tel' ) {
            this.props.closeGenaralModal();
            this.setState({ is_show: false }); 
            let param = { token: _getToken(), platform: variable().platform, data_type: t, data_edit: this.state.tel.replace(' ', '').replace(' ', '') };
            _post('web.edit.dashboard.php', param)
            .then(res => {
                if ( res.data.status ) { 
                    this.props.onFallback(true);
                    _Alert('modify', 'success', 'แก้ไขข้อมูลสำเร็จแล้ว', 'แก้ไขข้อมูลสำเร็จแล้ว');
                } else {
                    this.setState({ loadingShow: false });
                    if ( res.data.responseText === 101 ) {
                        localStorage.clear();
                        _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
                    } else {
                        _Alert('modify', 'error', 'แจ้งเตือน', res.data.responseText);
                    }
                }
            }).catch(err => { 
                this.setState({ loadingShow: false }); 
                _Alert('error'); 
            });
        } else if ( t === 'mobile' ) {
            this.props.closeGenaralModal();
            this.setState({ is_show: false }); 
            let param = { token: _getToken(), platform: variable().platform, data_type: t, data_edit: this.state.mobile.replace(' ', '').replace(' ', '') };
            _post('web.edit.dashboard.php', param)
            .then(res => {
                if ( res.data.status ) { 
                    this.props.onFallback(true);
                    _Alert('modify', 'success', 'แก้ไขข้อมูลสำเร็จแล้ว', 'แก้ไขข้อมูลสำเร็จแล้ว');
                } else {
                    this.setState({ loadingShow: false });
                    if ( res.data.responseText === 101 ) {
                        localStorage.clear();
                        _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
                    } else {
                        _Alert('modify', 'error', 'แจ้งเตือน', res.data.responseText);
                    }
                }
            }).catch(err => { 
                this.setState({ loadingShow: false }); 
                _Alert('error'); 
            });
        }
    }

    onOpenModal = (component) => {
        this.setState({ genaral_modal: { is_show: true, component: component } });
    }
     
    onCloseModal = () => {
        this.setState({ is_show: false, component: '' });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ 
            is_show: nextProps.onShowGenaralModal, 
            component: nextProps.onComponent,
            tel: nextProps.onInfo.tel,
            mobile: nextProps.onInfo.mobile,
            email: nextProps.onInfo.email
        });
    }

    genComponentModalGenaral() {
        if ( this.state.component === 'email' ) {
            return (
                <div className="modal-content-genaral">
                    <div className="input-group mb-3 txt-input">
                        <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                            <i className="fas fa-at"></i>
                        </span>
                        </div>
                        <InputMask className="form-control" maskChar={null} placeholder="กรุณากรอก e-mail (abc@gmail.com)" value={this.state.email} onChange={(e) => this.update("email", e)} />
                    </div>
                    <div className="register-row">
                        <button type="button" className="btn btn-light btn-lg" onClick={(e) => this.EditDataGenaral('email')}>แก้ไข</button>
                    </div> 
                </div>
            )
        } else if ( this.state.component === 'tel' ) {
            return (
                <div className="modal-content-genaral">
                <div className="input-group mb-3 txt-input">
                    <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                        <i className="fas fa-phone-volume"></i>
                    </span>
                    </div>
                    <InputMask className="form-control" mask="9 9999 9999" maskChar={null} placeholder="เบอร์โทรศัพท์บ้าน 9 หลัก" value={this.state.tel} onChange={(e) => this.update("tel", e)} />
                </div>
                <div className="register-row">
                    <button type="button" className="btn btn-light btn-lg" onClick={(e) => this.EditDataGenaral('tel')}>แก้ไข</button>
                </div> 
                </div>
            )
        } else if ( this.state.component === 'mobile' ) {
            return (
                <div className="modal-content-genaral">
                <div className="input-group mb-3 txt-input">
                    <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                        <i className="fas fa-mobile-alt"></i>
                    </span>
                    </div>
                    <InputMask className="form-control" mask="99 9999 9999" maskChar={null} placeholder="เบอร์โทรศัพท์มือถือ 10 หลัก" value={this.state.mobile} onChange={(e) => this.update("mobile", e)} />
                </div>
                <div className="register-row">
                    <button type="button" className="btn btn-light btn-lg" onClick={(e) => this.EditDataGenaral('mobile')}>แก้ไข</button>
                </div> 
                </div>
            )
        }
    }

    render() {
        return (
            <Modal open={this.state.is_show} onClose={(e) => this.onCloseModal()} center>
                <div className="modal-title">แก้ไขข้อมูล</div>
                {this.genComponentModalGenaral()}
            </Modal>
        )
    }
}

export default ModalGenaral;